import { Injectable, HostListener } from '@angular/core';

import swal from 'sweetalert2';
import { ArgumentOutOfRangeError } from 'rxjs';

@Injectable()
export class UiService {

  public showSidebar = true;
  public unreadCount = 0;

  public _loaderCounter = 0;
  get loaderState() {
    return this._loaderCounter !== 0;
  }

  public loader = {
    show: (...logData) => {
      // setTimeout(() => { this._loaderCounter++; }, 0);
      this._loaderCounter++;
      console.log('loader_show', this._loaderCounter, ...logData);
    },
    hide: (...logData) => {
      // setTimeout(() => { this._loaderCounter--; }, 0);
      this._loaderCounter--;
      console.log('loader_hide', this._loaderCounter, ...logData);
    },
    reset: (...logData) => {
      console.log('loader_reset');
      this._loaderCounter = 0;
      console.log('loader_reset', this._loaderCounter, ...logData);
    }
  }

  public alert = {
    error: (message) => {
      swal('Oops!', message, 'error');
    }
  }

  constructor() { }

  getLoaderState() {
    return this._loaderCounter;
  }

}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/services/ui/ui.service.ts